import React, { useRef } from "react";
import cx from 'classnames';
import styles from './toast.module.scss';

interface SuccessToastProps {
  className?: string;
  message: any;
  closeToast?: () => void;
  customContent?: any;
  heading?:string;
  actions?:React.ReactNode;
}

 const SucessToast:React.FC<SuccessToastProps> = ({className, message, closeToast, customContent}) => {
  return (
    <div className={cx(styles.toast, styles.success, className)}>
      <button className={styles.closeButton} onClick={closeToast}>
        <i className="fa-regular fa-circle-xmark"></i>
      </button>
      <div className={styles.content}>
        <h6 className={styles.heading}><i className="paperflite-tick"/> Success</h6>
        {customContent ? customContent : (<p className={styles.message}>{message}</p>)}
      </div>
    </div>
  );
}


const FailureToast:React.FC<SuccessToastProps> = ({className, heading, message, closeToast}) => {    
  return (
    <div className={cx( styles.toast, styles.failure, className)}>
      <button className={styles.closeButton} onClick={closeToast}>
      <i className="fa-regular fa-circle-xmark"></i>
      </button>
      <div className={styles.content}>
        <h6 className={styles.heading}> <i className="paperflite-exclamatory"/>{heading ? heading : "Hold on!"}</h6>
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
}

const WarningToast:React.FC<SuccessToastProps> = ({className, heading, message, closeToast, actions}) => {
  return (
    <div className={cx( styles.toast, styles.warning, className)}>
      <button className={styles.closeButton} onClick={closeToast}>
      <i className="fa-regular fa-circle-xmark"></i>
      </button>
      <div className={styles.content}>
        <h6 className={styles.heading}> <i className="fa-solid fa-warning"/> {heading} </h6>
        <p className={styles.message}>{message}</p>
        {actions && actions}
      </div>
    </div>
  );
}

const ProgressToast:React.FC<SuccessToastProps> = ({className, heading, message, closeToast, actions}) => {
  return (
    <div className={cx( styles.toast, styles.progress, className)}>
      <button className={styles.closeButton} onClick={closeToast}>
      <i className="fa-regular fa-circle-xmark"></i>
      </button>
      <div className={styles.content}>
        <h6 className={styles.heading}> <i className="paperflite-history"/> {heading} </h6>
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
}

const Toast = {
  Sucess: SucessToast,
  Failure: FailureToast,
  warning: WarningToast,
  Progress: ProgressToast
}

export default Toast;